import React from "react";
import classes from "./selectInput.module.scss";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Select from "react-select";

const SelectInput = (props) => {
  const classModifier = props.classModifier
    ? classes[props.classModifier]
    : null;
  const dispatch = useDispatch();
  return (
    <div className={`${classes.select__wrapper} ${classModifier}`}>
      <Select
        options={props.options}
        name={props.name}
        placeholder={props.placeholder}
        className="basic-single"
        onChange={(val) =>
          dispatch(props.onChange(props.form, val, props.name))
        }
        isDisabled={props.disabled}
      />
    </div>
  );
};

Select.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

export default SelectInput;
